//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"AnchorPointLocation",0,0],[0,"SymbolAnnotationAnchor",1,0],[0,"SymbolAnnotationOrientation",1,0],[0,"SymbolAnnotationPoint",1,0]],[[["propertyName","propertyReference"],"AddCheckedAttribute",{},2,0],[[],"ResetPropertyList",{},0,0]],[]];
SPLM.AME.SymbolAnnotationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.SymbolAnnotationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.SymbolAnnotationBuilder.Orientation = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical"});

SPLM.AME.SymbolAnnotationBuilder.Anchor = Object.freeze({
    "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "MiddleLeft" : "MiddleLeft", "MiddleCenter" : "MiddleCenter", "MiddleRight" : "MiddleRight", "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

export default SPLM;